module.exports = __webpack_public_path__ + "assets/6ce682382fe2a61ff12c2b04466f4ecd.png";